import { render, staticRenderFns } from "./UserChangePhoneModal.vue?vue&type=template&id=9254dcde&"
import script from "./UserChangePhoneModal.vue?vue&type=script&lang=js&"
export * from "./UserChangePhoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports